import { axiosInstance } from 'boot/axios';
import Notify from 'src/constants/notify';
import { dataModificationRedirect } from 'src/utils/helpers.js';
import Customer from 'src/models/customer.js';
import isEmpty from 'lodash/isEmpty';
import i18n from 'src/i18n/index.js';
import { toRaw } from 'vue';

export function getAllCustomersWithPolicyForYear({ commit }, payload) {
  commit('setIsLoadingCustomers', true);
  return axiosInstance
    .get(`Customer/GetAllCustomersWithPolicyForYear?year=${payload.year}&checkForOffer=${payload.checkForOffer}`)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'setCustomers',
          response.data.map((customer) => new Customer(customer)),
        );
      }
    })
    .finally(() => commit('setIsLoadingCustomers', false));
}

export function getAllCustomersWithActiveInsuranceCard({ commit }) {
  commit('setIsLoadingCustomers', true);
  return axiosInstance
    .get('Customer/getAllCustomersWithActiveInsuranceCard')
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'setCustomers',
          response.data.map((customer) => new Customer(customer)),
        );
      }
    })
    .finally(() => commit('setIsLoadingCustomers', false));
}

export function getAllCustomersWithPolicy({ commit }) {
  commit('setIsLoadingCustomers', true);
  return axiosInstance
    .get('Customer/GetAllCustomersWithPolicy')
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'setCustomers',
          response.data.map((customer) => new Customer(customer)),
        );
      }
    })
    .finally(() => commit('setIsLoadingCustomers', false));
}

export function getAllCustomersWithPolicyInPast({ commit }) {
  commit('setIsLoadingCustomers', true);
  return axiosInstance
    .get('Customer/GetAllCustomersWithPolicyInPast')
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'setCustomers',
          response.data.map((customer) => new Customer(customer)),
        );
      }
    })
    .finally(() => commit('setIsLoadingCustomers', false));
}

export function getCustomerDetails({ commit, rootState }, customerNumber) {
  if (!rootState.user.permissions.mayReadPersonalDetails) return;
  commit('setIsLoadingCustomers', true);
  return axiosInstance
    .get(`Customer/GetCustomerDetails/?customerNumber=${customerNumber}`)
    .then((response) => {
      const customer = new Customer(response.data.customer);
      commit('addCustomerDetails', {
        customer: customer,
        customerDetails: response.data,
      });
    })
    .finally(() => commit('setIsLoadingCustomers', false));
}

export function clearCustomers({ commit }) {
  commit('clearCustomers');
}
export function clearCustomerUserDetails({ commit }) {
  commit('clearCustomerUserDetails');
}

export function updateCustomer(_, payload) {
  return axiosInstance
    .post('Customer/UpdateCustomer', toRaw(payload))
    .then(() => {
      Notify.create({
        progress: true,
        icon: 'done',
        color: 'positive',
        message: i18n.global.t('edit-personal-info.valid'),
      });
      dataModificationRedirect('personal-info', this.$router);
    })
    .catch((error) => {
      Notify.create(
        {
          color: 'negative',
          message: i18n.global.t('edit-personal-info.error-saving'),
        },
        error.response,
      );
    });
}

export function getAllCustomersWithActivePolicy({ commit }) {
  commit('setIsLoadingCustomers', true);
  return axiosInstance
    .get('Customer/GetAllCustomersWithActivePolicy')
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'setCustomers',
          response.data.map((customer) => new Customer(customer)),
        );
      }
    })
    .finally(() => commit('setIsLoadingCustomers', false));
}
